import { render } from "./StatusCommissions.vue?vue&type=template&id=19820692&scoped=true"
import script from "./StatusCommissions.vue?vue&type=script&lang=js"
export * from "./StatusCommissions.vue?vue&type=script&lang=js"

import "./custom-status-commissions.scss?vue&type=style&index=0&id=19820692&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19820692"]])

export default __exports__